import moment from 'moment-timezone';

// tslint:disable: max-classes-per-file
import {
  IDayTradesDetailResponse,
  IDayTradesKeyDetailResponse,
  IDayTradesResponse,
} from '../responses/day-trades.response';

export interface IDayTradesDetail {
  id: string;
  contractId: string;
  accountId: string;
  amount: number;
  instrumentId: string;
  orderType: string;
  side: string;
  filledQuantity: number;
  status: string;
  price: number;
  createdHour: string;
  createdDate: string;
}

export interface IDayTradesOrders {
  instrumentId: string;
  isVirtual: boolean;
  orders: IDayTradesDetail[];
}

export interface IPotencialDayTradesDetail {
  instrumentId: string;
  side: string;
}

export interface IDayTradesKeyDetail {
  [Key: string]: IDayTradesDetail[];
}

export interface IDayTrades {
  nextAvailableDayTrade: string;
  isDayTradeValidationActive: boolean;
  dayTrades?: IDayTradesOrders[];
  potencialDayTrades?: IPotencialDayTradesDetail[];
}

export class DayTradesViewModel implements IDayTrades {
  static fromJSON(json: IDayTradesResponse): DayTradesViewModel {
    return new DayTradesViewModel(
      json.next_available_day_trade,
      json.is_day_trade_validation_active,
      this.getDayTrades(json.day_trades),
      this.getPotencialDayTrades(json.potential_day_trades),
    );
  }

  static getDayTrades(trades: IDayTradesKeyDetailResponse[]) {
    return trades.map((item) => {
      return DayTradesModel.fromJSON(item);
    });
  }

  static getPotencialDayTrades(trades: any) {
    const potencialDayTrades: IPotencialDayTradesDetail[] = trades.map(
      (item: any) => {
        return Object.assign(
          {},
          {
            instrumentId: item.instrument_id,
            side: item.side,
          },
        );
      },
    );

    return potencialDayTrades;
  }

  constructor(
    public nextAvailableDayTrade: string,
    public isDayTradeValidationActive: boolean,
    public dayTrades?: any,
    public potencialDayTrades?: IPotencialDayTradesDetail[],
  ) {}

  public showDayTrade(): boolean {
    const virtualDayTrade = this.dayTrades.filter((item: any) => {
      return item.isVirtual;
    });

    const dayTrade = this.dayTrades.filter((item: any) => {
      return !item.isVirtual;
    });

    return (
      this.isDayTradeValidationActive &&
      (virtualDayTrade.length >= 2 || dayTrade.length)
    );
  }
}

export class DayTradesModel implements IDayTradesOrders {
  static fromJSON(json: IDayTradesKeyDetailResponse): DayTradesModel {
    return new DayTradesModel(
      json.instrument_id,
      json.is_virtual,
      this.getDayTradesOrders(json.orders),
    );
  }

  static getDayTradesOrders(
    trades: IDayTradesDetailResponse[],
  ): DayTradesDetailViewModel[] {
    return trades.map((item) => {
      return DayTradesDetailViewModel.fromJSON(item);
    });
  }

  constructor(
    public instrumentId: string,
    public isVirtual: boolean,
    public orders: DayTradesDetailViewModel[],
  ) {}
}

export class DayTradesDetailViewModel implements IDayTradesDetail {
  static fromJSON(json: IDayTradesDetailResponse): DayTradesDetailViewModel {
    const SIDE: any = {
      buy: 'Compra',
      sell: 'Venta',
    };

    return new DayTradesDetailViewModel(
      json.id,
      json.contract_id,
      json.account_id,
      json.amount,
      json.instrument_id,
      json.order_type,
      SIDE[json.side],
      json.filled_quantity,
      json.status,
      json.price,
      moment(json.created_date).format('LT'),
      moment(json.created_date).format('LL'),
    );
  }

  constructor(
    public id: string,
    public contractId: string,
    public accountId: string,
    public amount: number,
    public instrumentId: string,
    public orderType: string,
    public side: string,
    public filledQuantity: number,
    public status: string,
    public price: number,
    public createdHour: string,
    public createdDate: string,
  ) {}
}
